'use client';

import { useEffect, useState } from 'react';
import HeroBranding from './HeroBranding';
import InstructionSteps from './InstructionSteps';
import AccessCodeForm from './AccessCodeForm';
import PrivacyNotice from './PrivacyNotice';
import Icon from '@/components/ui/AppIcon';
import { useOnlineCount } from '@/hooks/useOnlineCount';

export default function AccessCodeInteractive() {
  const [showExpiredNotice, setShowExpiredNotice] = useState(false);
  // Join the presence channel so this page is counted in the online total
  useOnlineCount();

  useEffect(() => {
    if (localStorage.getItem('session_expired_notice') === '1') {
      localStorage.removeItem('session_expired_notice');
      setShowExpiredNotice(true);
      const t = setTimeout(() => setShowExpiredNotice(false), 22000);
      return () => clearTimeout(t);
    }
  }, []);

  return (
    <div className="w-full max-w-lg mx-auto px-4">
      {/* Session expired notification */}
      {showExpiredNotice && (
        <div
          className="mb-5 flex items-start gap-3 border border-[#a40e10]/50 bg-[#a40e10]/10 px-4 py-3"
          style={{ borderRadius: '2px' }}
        >
          <Icon name="ClockIcon" size={16} variant="outline" className="text-[#a40e10] flex-shrink-0 mt-0.5" />
          <div>
            <p className="font-mono text-xs text-[#a40e10] uppercase tracking-wider font-semibold">
              Code aufgebraucht
            </p>
            <p className="font-body text-xs text-muted-foreground mt-0.5 leading-relaxed">
              Dein zeitlich limitierter Code wurde aufgebraucht. Du benötigst einen neuen Code, um fortzufahren.
            </p>
          </div>
          <button
            onClick={() => setShowExpiredNotice(false)}
            className="ml-auto text-muted-foreground hover:text-foreground transition-colors flex-shrink-0"
            aria-label="Hinweis schließen"
          >
            <Icon name="XMarkIcon" size={14} variant="outline" />
          </button>
        </div>
      )}

      <HeroBranding />
      <InstructionSteps />
      {/* Main card */}
      <div
        className="bg-card border-2 border-white/5 p-6 md:p-8 shadow-2xl relative overflow-hidden"
        style={{ borderRadius: '2px' }}
      >
        {/* Card inner top accent */}
        <div className="absolute top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-primary to-transparent" />

        <div className="mb-6">
          <h2 className="font-heading text-xl text-foreground uppercase tracking-wide mb-1">
            Zugangscode eingeben
          </h2>
          <p className="font-body text-sm text-muted-foreground leading-relaxed">
            Exklusiver Zugang für Instagram-Community-Mitglieder. Gib deinen 8-stelligen Code ein, um die Karte zu betreten.
          </p>
        </div>

        <AccessCodeForm />
      </div>
      <PrivacyNotice />
      {/* Footer note */}
      <p className="text-center font-mono text-xs text-muted-foreground/40 mt-6 uppercase tracking-widest">
        &copy; 2026 COPTERSTORIES · Alle Rechte vorbehalten
      </p>
    </div>
  );
}